export const handleExcelExport = (documentName, url, body) => {
    const token = localStorage.getItem('token');
    const options = {
        method: 'POST',
        body: body ? JSON.stringify(body) : undefined,
        headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`,
        },
    };
    return fetch(`${url}generate-excel/${documentName}`, options)
        .then((response) => {
        if (response.ok) {
            return response.blob();
        }
    })
        .then((blob) => {
        if (blob) {
            const a = window.document.createElement('a');
            const downloadUrl = window.URL.createObjectURL(blob);
            a.href = downloadUrl;
            a.download = `${documentName}-${Date.now()}.xlsx`;
            document.body.appendChild(a);
            a.click();
            document.body.removeChild(a);
            window.URL.revokeObjectURL(downloadUrl);
        }
    });
};
//# sourceMappingURL=handleExcelExport.js.map